import { Alert, Snackbar, Stack } from '@mui/material';
import { useNotificationStore } from '@/stores/use-notification-store';

export function NotificationSnackbar() {
    const { notifications, removeNotification } = useNotificationStore();

    return (
        <Stack spacing={1} sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999 }}>
            {notifications.map((notification) => (
                <Snackbar
                    key={notification.id}
                    open={true}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert
                        severity={notification.type}
                        onClose={() => removeNotification(notification.id)}
                        variant="filled"
                        sx={{ minWidth: 300 }}
                    >
                        {notification.message}
                    </Alert>
                </Snackbar>
            ))}
        </Stack>
    );
}

export default NotificationSnackbar;
